import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { FieldArray, reduxForm, SubmissionError } from 'redux-form';

import FiltersFieldArray from 'components/fields/FiltersFieldArray';
import Typography from '@material-ui/core/Typography';

import { changePatientResource } from 'redux/modules/patients';

const styles = () => ({
  typographySubtitle: {
    marginBottom: 24,
  },
});

function onSubmit(values, dispatch, props) {
  const referralSourceID = values['Referral Source'].map(item => item.value);
  if (props.variant === 'referralSource') {
    return new Promise((resolve, reject) => {
      dispatch(changePatientResource({
        'Record Number': props['Record Number'],
        'Referral Source': [
          ...referralSourceID.map(id => ({ id })),
          ...props['Referral Source'].map(item => ({ id: item.ID })),
        ],
        resolve,
        reject,
      }));
    })
    .then(res => ({
      variant: props.variant,
      'Referral Source': res['Referral Source'].filter(item => referralSourceID.indexOf(item.ID) !== -1),
    }),
      (err) => {
        throw new SubmissionError(err);
      });
  } else {
    return new Promise((resolve, reject) => {
      dispatch(changePatientResource({
        'Record Number': props['Record Number'],
        'Sales Representative ID': [
          ...values['Sales Representative'].map(item => item.value),
          ...props['Sales Representative'].map(item => item.ID),
        ],
        resolve,
        reject,
      }));
    })
    .then(res => res,
      (err) => {
        throw new SubmissionError(err);
      });
  }
}

const PrescribersLinkedForm = ({
  className,
  handleSubmit,
  disabled,
  change,
  onCreateButtonClick,
  variant,
  actions,
  formValues,
  account,
  prescriber,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Typography className={classes.typographySubtitle}>
      {variant === 'sales' ? 'We found these Sales Reps linked with this Referral Source. You can select one or more of these Sales Reps. If you do not see the Sales Rep then you can always add a new one.'
        : 'We found these Referral Sources linked with this Prescriber. You can select one or more of these Referral Sources. If you do not see the Referral Source then you can always add a new one and link it to this Doctor.'}
    </Typography>
    {variant === 'sales' ? (
      <FieldArray
        id="Sales Representative"
        // eslint-disable-next-line react/no-array-index-key
        name="Sales Representative"
        component={FiltersFieldArray}
      />
    ) : (
      <FieldArray
        id="Referral Source"
        // eslint-disable-next-line react/no-array-index-key
        name="Referral Source"
        component={FiltersFieldArray}
      />
    )}
  </form>
);

PrescribersLinkedForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  onCreateButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['sales', 'referralSource']),
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  prescriber: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};

PrescribersLinkedForm.defaultProps = {
  variant: 'default',
  className: '',
  disabled: false,
  onCreateButtonClick: () => {},
  formValues: {},
  prescriber: [],
};

export default reduxForm({
  onSubmit,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(withStyles(styles)(PrescribersLinkedForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Prescribers/PrescribersLinkedForm.js